export enum TemplateItemType{
    horizontal,
    vertical,
    square
}